import React, { useEffect, useState, useRef } from 'react';
import { collection, onSnapshot, doc, setDoc, getDoc, getDocs, updateDoc } from 'firebase/firestore';
import { firestore } from './../../FirebaseUtils';
import QuestionCard from './QuestionCard';
import { Alert, Button, Table } from 'react-bootstrap';
import ArrowUp from '../symbol/ArrowUp';
import ArrowDown from '../symbol/ArrowDown';

function AdminUsers() {
    const [ loading, setLoading ] = useState(true);
    const [ errorMessage, setErrorMessage ] = useState();

    const [ processing, setProcessing ] = useState(false);

    const [ employees, setEmployees ] = useState([]);
    const [ users, setUsers ] = useState([]);

    const [ employeeCount, setEmployeeCount ] = useState(0);
    const [ nonEmployeeCount, setNonEmployeeCount ] = useState(0);

    const [ today, setToday ] = useState(new Date());

    const sortByEmployeeIdAsc = (elem1, elem2) => {
        if (elem1.employeeId === undefined || elem2.employeeId === undefined) {
            return sortByNameAsc(elem1, elem2);
        }
        return elem1.employeeId.localeCompare(elem2.employeeId);
    }

    const sortByEmployeeIdDesc = (elem1, elem2) => {
        if (elem1.employeeId === undefined || elem2.employeeId === undefined) {
            return sortByNameDesc(elem1, elem2);
        }
        return elem2.employeeId.localeCompare(elem1.employeeId);
    }

    const sortByEmailAsc = (elem1, elem2) => {
        if (!elem1.email || !elem2.email) return 0;
        return elem1.email.localeCompare(elem2.email);
    }

    const sortByEmailDesc = (elem1, elem2) => {
        if (!elem1.email || !elem2.email) return 0;
        return elem2.email.localeCompare(elem1.email);
    }

    const sortByNameAsc = (elem1, elem2) => {
        if (elem1.name === undefined || elem2.name === undefined) return 0;
        return elem1.name.localeCompare(elem2.name);
    }

    const sortByNameDesc = (elem1, elem2) => {
        if (elem1.name === undefined || elem2.name === undefined) return 0;
        return elem2.name.localeCompare(elem1.name);
    }

    const sortBySurnameAsc = (elem1, elem2) => {
        if (elem1.surname === undefined || elem2.surname === undefined) return 0;
        return elem1.surname.localeCompare(elem2.surname);
    }

    const sortBySurnameDesc = (elem1, elem2) => {
        if (elem1.surname === undefined || elem2.surname === undefined) return 0;
        return elem2.surname.localeCompare(elem1.surname);
    }

    const sortByIsBannedAsc = (elem1, elem2) => {
        if (elem1.isBanned === elem2.isBanned) return sortByEmployeeIdAsc(elem1, elem2);
        return (elem1.isBanned ? 1 : 0) - (elem2.isBanned ? 1 : 0);
    }

    const sortByIsBannedDesc = (elem1, elem2) => {
        if (elem1.isBanned === elem2.isBanned) return sortByEmployeeIdDesc(elem1, elem2);
        return (elem2.isBanned ? 1 : 0) - (elem1.isBanned ? 1 : 0);
    }

    const [ sortBy, setSortBy ] = useState("sortByEmployeeIdAsc");
    const [ sortFunc, setSortFunc ] = useState(() => sortByEmployeeIdAsc);

    useEffect(() => {
        load();
    }, []);

    async function load() {
        setLoading(true);

        const employeesData = await loadEmployees();
        await loadUsers(employeesData);

        setLoading(false);
    }

    async function loadEmployees() {
        const employeesRef = collection(firestore, 'employees');

        const querySnapshot = await getDocs(employeesRef);
        const employeesData = querySnapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
        }));
        setEmployees(employeesData);

        return employeesData;
    }

    async function loadUsers(employeesData) {
        const docsRef = collection(firestore, 'users');

        const querySnapshot = await getDocs(docsRef);
        const usersData = querySnapshot.docs.map((doc) => {
            const employee = employeesData.find((el) => el.email === doc.data().email);

            return ({
                id: doc.id,
                employeeId: employee ? employee.id : '',
                ...doc.data(),
            })
        });
        setUsers(usersData);

        let n1 = 0;
        let n2 = 0;
        for (let i = 0; i < usersData.length; i++) {
            if (usersData[i].employeeId !== '') {
                n1 = n1 + 1;
            }
            else {
                n2 = n2 + 1;
            }
        }

        setEmployeeCount(n1);
        setNonEmployeeCount(n2);
    }

    function onClickSortByEmployeeId(e) {
        console.log(sortBy);

        if (sortBy === "sortByEmployeeIdAsc") {
            setSortBy("sortByEmployeeIdDesc");
            setSortFunc(() => sortByEmployeeIdDesc);
        }
        else {
            setSortBy("sortByEmployeeIdAsc");
            setSortFunc(() => sortByEmployeeIdAsc);
        }
    }

    function getArrowIconForEmployeeIdHeader() {
        if (sortBy === "sortByEmployeeIdDesc") {
            return <ArrowUp />
        }
        else if (sortBy === "sortByEmployeeIdAsc") {
            return <ArrowDown />
        }
        return null;
    }

    function onClickSortByEmail(e) {
        console.log(sortBy);

        if (sortBy === "sortByEmailAsc") {
            setSortBy("sortByEmailDesc");
            setSortFunc(() => sortByEmailDesc);
        }
        else {
            setSortBy("sortByEmailAsc");
            setSortFunc(() => sortByEmailAsc);
        }
    }

    function getArrowIconForEmailHeader() {
        if (sortBy === "sortByEmailDesc") {
            return <ArrowUp />
        }
        else if (sortBy === "sortByEmailAsc") {
            return <ArrowDown />
        }
        return null;
    }

    function onClickSortByName(e) {
        console.log(sortBy);

        if (sortBy === "sortByNameAsc") {
            setSortBy("sortByNameDesc");
            setSortFunc(() => sortByNameDesc);
        }
        else {
            setSortBy("sortByNameAsc");
            setSortFunc(() => sortByNameAsc);
        }
    }

    function getArrowIconForNameHeader() {
        if (sortBy === "sortByNameDesc") {
            return <ArrowUp />
        }
        else if (sortBy === "sortByNameAsc") {
            return <ArrowDown />
        }
        return null;
    }

    function onClickSortBySurname(e) {
        console.log(sortBy);

        if (sortBy === "sortBySurnameAsc") {
            setSortBy("sortBySurnameDesc");
            setSortFunc(() => sortBySurnameDesc);
        }
        else {
            setSortBy("sortBySurnameAsc");
            setSortFunc(() => sortBySurnameAsc);
        }
    }

    function getArrowIconForSurnameHeader() {
        if (sortBy === "sortBySurnameDesc") {
            return <ArrowUp />
        }
        else if (sortBy === "sortBySurnameAsc") {
            return <ArrowDown />
        }
        return null;
    }

    function onClickSortByIsBanned(e) {
        console.log(sortBy);

        if (sortBy === "sortByIsBannedAsc") {
            setSortBy("sortByIsBannedDesc");
            setSortFunc(() => sortByIsBannedDesc);
        }
        else {
            setSortBy("sortByIsBannedAsc");
            setSortFunc(() => sortByIsBannedAsc);
        }
    }

    function getArrowIconForIsBannedHeader() {
        if (sortBy === "sortByIsBannedDesc") {
            return <ArrowUp />
        }
        else if (sortBy === "sortByIsBannedAsc") {
            return <ArrowDown />
        }
        return null;
    }

    async function banUser(employeeId, email, name, surname) {
        if (!window.confirm(`คุณต้องการระงับการใช้งานใช่หรือไม่\n\nรหัส: ${employeeId}\nอีเมล์: ${email}\nชื่อ: ${name}\nนามสกุล: ${surname}`)) {
            return;
        }

        setLoading(true);

        const userRef = doc(firestore, 'users', email);
        try {
            await updateDoc(userRef, {
                isBanned: true,
            });
            console.log('User banned status updated successfully!');
        }
        catch (error) {
            console.error('Error updating user banned status: ', error);
        }

        setLoading(false);

        load();
    }

    async function unbanUser(employeeId, email, name, surname) {
        if (!window.confirm(`คุณต้องยกเลิกการระงับการใช้งานใช่หรือไม่\n\nรหัส: ${employeeId}\nอีเมล์: ${email}\nชื่อ: ${name}\nนามสกุล: ${surname}`)) {
            return;
        }

        setLoading(true);

        const userRef = doc(firestore, 'users', email);
        try {
            await updateDoc(userRef, {
                isBanned: false,
            });
            console.log('User banned status updated successfully!');
        }
        catch (error) {
            console.error('Error updating user banned status: ', error);
        }

        setLoading(false);

        load();
    }

    function getMonthName(i) {
        switch (i) {
            case 0: return "มกราคม";
            case 1: return "กุมภาพันธ์";
            case 2: return "มีนาคม";
            case 3: return "เมษายน";
            case 4: return "พฤษภาคม";
            case 5: return "มิถุนายน";
            case 6: return "กรกฎาคม";
            case 7: return "สิงหาคม";
            case 8: return "กันยายน";
            case 9: return "ตุลาคม";
            case 10: return "พฤศจิกายน";
            case 11: return "ธันวาคม";
        }

        return "";
    }

    return (
        <div>
        { loading ? <div className='mb-5'>Loading ...</div> : null }

        {
            loading ?
                null
            :
                <div className='mt-3 mb-5'>
                    <div>วันที่ {today.getDate()}-{getMonthName(today.getMonth())}-{today.getFullYear()+543}</div>
                    <div>&nbsp;</div>
                    <div>จำนวนผู้ใช้งานทั้งหมด: {users.length}</div>
                    <div>จำนวนพนักงาน: {employeeCount}</div>
                    <div>จำนวนบุคคลทั่วไป: {nonEmployeeCount}</div>
                </div>
        }

        {
            users ?
                <Table>
                    <thead>
                        <tr style={{ borderBottom: '1px solid black', borderTop: '1px solid black' }}>
                            <td>{getArrowIconForEmployeeIdHeader()}&nbsp;<span className='sortable-table-header' onClick={onClickSortByEmployeeId}>รหัสพนักงาน</span></td>
                            <td>{getArrowIconForEmailHeader()}&nbsp;<span className='sortable-table-header' onClick={onClickSortByEmail}>อีเมล์</span></td>
                            <td>{getArrowIconForNameHeader()}&nbsp;<span className='sortable-table-header' onClick={onClickSortByName}>ชื่อ</span></td>
                            <td>{getArrowIconForSurnameHeader()}&nbsp;<span className='sortable-table-header' onClick={onClickSortBySurname}>นามสกุล</span></td>
                            <td>{getArrowIconForIsBannedHeader()}&nbsp;<span className='sortable-table-header' onClick={onClickSortByIsBanned}>การถูกระงับใช้งาน</span></td>
                            <td></td>
                        </tr>
                    </thead>
                    <tbody>
                    {
                        users.sort((elem1, elem2) => sortFunc(elem1, elem2)).map((user, i) => {
                            return (
                                <tr key={`user_${i}`}>
                                    <td>{user.employeeId}</td>
                                    <td>{user.email}</td>
                                    <td>{user.name}</td>
                                    <td>{user.surname}</td>
                                    <td>{user.isBanned ? <span style={{color:'red'}}>ถูกระงับการใช้งาน</span> : "ใช้งานได้ปกติ"}</td>
                                    <td>
                                    {
                                        user.isBanned ?
                                            <Button disabled={loading} variant='outline-warning' size='sm' onClick={(e) => unbanUser(user.employeeId, user.email, user.name, user.surname)}>ยกเลิกการระงับใช้งาน</Button>
                                        :
                                            <Button disabled={loading} variant='outline-danger' size='sm' onClick={(e) => banUser(user.employeeId, user.email, user.name, user.surname)}>ระงับการใช้งาน</Button>
                                    }
                                    </td>
                                </tr>
                            );
                        })
                        
                    }
                    </tbody>
                </Table>
            :
                null
        }
        </div>
    );
}

export default AdminUsers;
